import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslatePipe } from '@ngx-translate/core';
import { AbstractFormFieldComponent } from '../../abstract-form-field.component';
import { CheckboxGroupComponent } from '../../controls/checkbox-group/checkbox-group.component';
import { CheckboxFormGroupField } from '../../form-field.model';

@Component({
  selector: 'iot-platform-ui-form-checkbox-group-field',
  imports: [
    FlexLayoutModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    ReactiveFormsModule,
    TranslatePipe,
    MatTooltipModule,
    CheckboxGroupComponent,
    FormsModule
  ],
  templateUrl: './form-checkbox-group-field.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: '../../form-field/form-field.component.scss'
})
export class FormCheckboxGroupFieldComponent extends AbstractFormFieldComponent<CheckboxFormGroupField> {}
